<vcl-modal id="termsModal" [modalTitle]="terms.title" *ngIf="showModal" [(showModal)]="showModal"
  [buttonLabels]="buttonLabelsModal" (modalButtonClick)="modalAction($event)">
  <p id="pdfText" [innerHtml]="terms.text" *ngIf="showSecondaryButton"></p>
</vcl-modal>
<vcl-modal id="termsModal" [modalTitle]="terms.title" *ngIf="showModalTerm" [(showModal)]="showModalTerm"
  [buttonLabels]="buttonLabelsModalTerms" (modalButtonClick)="modalActionTerms($event)">
  <p class="text_modal" [innerHtml]="terms.text"></p>
</vcl-modal>

<div class="detail-account-creation" *ngIf="!viewOptionMultiProduct">
  <h2 class="subtitle">
    {{copyService.getParametrizedCopy(copiesProperty['mainLabel'], [documentInfo.firstname])}}
  </h2>
  <div *ngIf="lifeMiles && selectedProduct.name === 'CreditTarget' && !grayZone">
    <div class="subTitle">Sin cuota de manejo</div>
    <p class="credit-text" *ngFor="let transactionkit of transactionkitMono">
      <span [innerHtml]="transactionkit.description"> </span>
    </p>
  </div>
  <div class="type-account flexDirection" *ngIf="selectedProduct.name === 'Payroll'">
    <div class="titleDirection">
      <div class="icon">
        <em class="icon-itaufonts_mala"></em>
      </div>
      <div class="text">
        <strong>{{ copyService.copies.detail_account_creation_label_payroll }}</strong>
      </div>
    </div>
    <div class="companyAgreement">
      <strong>Empresa</strong>
      <p>{{ agreementSelected.agreement_name }}</p>
    </div>
  </div>

  <div class="type-account">
    <div class="icon" _icon-credit-card>
      <em
        [ngClass]="(selectedProduct.name === 'CreditTarget')?'icon-itaufonts_cartao':'icon-itaufonts_conta_corrente'"></em>
    </div>
    <div class="text">
      <strong>
        <ng-container *ngIf="(selectedProduct.name === 'CreditTarget' && grayZone); else else_condition">
          {{ copyService.copies.successful_account_creation_account_numberCredit_label_zng_title }}
        </ng-container>
        <ng-template #else_condition>
          <ng-container>
            {{ copyService.copies[copiesProperty['transactionsLabel']] }}
          </ng-container>
        </ng-template>
      </strong>
    </div>
  </div>

  <ul>
    <vcl-list *ngIf="selectedProduct.name === 'Saving Account' ||
            (selectedProduct.name === 'Payroll' && (agreementSelected && agreementSelected.transaction_type === 'true')) ||
            (selectedProduct.name === 'CreditTarget' && grayZone)">
      <li *ngFor="let detail of transactionkit.detail" vclListSimple>
        <em class="bullet icon-itaufonts_chat_enviado"></em>
        <vcl-list-text>
          <div class="text">{{ detail.detail }}</div>
          <div class="sub-text" [innerHtml]="detail.value"></div>
        </vcl-list-text>
      </li>
    </vcl-list>
    <div *ngIf="selectedProduct.name === 'CreditTarget' && !grayZone">
      <h1 class="amountNumber">{{ copyService.getParametrizedCopy('detail_account_creation_amount_approved_number',
        [amountPco]) }}</h1>
      <h2 class="subTitleTC">{{ copyService.copies.detail_account_creation_amount_approved }}</h2>
      <div class="cardImages">
        <img id="visaCreditCard" class="image" src="assets/images/icon-card.svg" alt="Visa"
          *ngIf="selectedPayDayProduct.elementId !== 1" />
        <img id="visaCreditCard" class="image" src="assets/images/Mastercard_preto.svg" alt="MasterCard"
          *ngIf="selectedPayDayProduct.elementId === 1" />
      </div>
      <vcl-list>
        <li *ngFor="let detail of transactionkit.detail" vclListSimple>
          <vcl-list-text>
            <div class="titleTC">{{ detail.detail }}</div>
            <div class="subTitleTC">{{ detail.value }}</div>
          </vcl-list-text>
        </li>
      </vcl-list>
    </div>

    <div class="note" *ngIf="selectedProduct.name === 'Saving Account' || 
    (selectedProduct.name === 'Payroll' && ( agreementSelected && agreementSelected.transaction_type === 'true'))">
      <div class="title">{{ copyService.copies.detail_account_creation_label_use_dont_pay }}</div>
      <div class="description" [innerHTML]='transactionkit.share[0].description'></div>

      <div class="description" *ngIf="transactionkit.id != 1 && (selectedProduct.name === 'Saving Account' ||
        (selectedProduct.name === 'Payroll' && (agreementSelected && agreementSelected.transaction_type === 'true')))">
        {{ selectedProduct.detail_product.characteristics.note }}
      </div>
    </div>

    <vcl-list *ngIf="selectedProduct.name === 'Saving Account' ||
        (selectedProduct.name === 'Payroll' && (agreementSelected && agreementSelected.transaction_type === 'false'))">
      <li *ngFor="let benefit of benefitsList" vclListSimple>
        <em class="bullet icon-itaufonts_chat_enviado"></em>
        <vcl-list-text>
          <div class="text">{{ benefit }}</div>
        </vcl-list-text>
      </li>
    </vcl-list>
  </ul>

  <div class="note" *ngIf="selectedProduct.name === 'CreditTarget'">
    <div
      *ngIf="(selectedProduct.name === 'CreditTarget' || selectedProduct.name === 'CreditTarget2' && (cardType.plan_comision !== 'Usa y No Pagues') && !grayZone);else use_pay_condition">
    </div>
    <ng-template #use_pay_condition>
      <div class="title">{{ copyService.copies.detail_account_creation_label_use_dont_pay }}</div>
      <div
        *ngIf="selectedProduct.name !== 'CreditTarget' || (selectedProduct.name === 'CreditTarget' ||  selectedProduct.name === 'CreditTarget2' && !grayZone)"
        class="description">
        <p class="description">{{transactionkit.share[0].description }}</p>
        <p class="description">{{ copyService.copies.detail_account_creation_transaction_tc }}</p>
      </div>
      <div *ngIf="selectedProduct.name === 'CreditTarget' || selectedProduct.name === 'CreditTarget2' && grayZone"
        class="description">
        {{ transactionkit.share[1].description }}
        <a class="link link-underline" target="_blank">
          {{copyService.copies.message_grayzone_existent_find_more_information_link}}
        </a>
      </div>
    </ng-template>

    <div class="description"
      *ngIf="transactionkit.id != 1 && (selectedProduct.name === 'Saving Account' ||
            (selectedProduct.name === 'Payroll' && (agreementSelected && agreementSelected.transaction_type === 'true')))">
      {{ selectedProduct.detail_product.characteristics.note }}
    </div>
  </div>

  <div class="terms">
    <voxel-checkbox [id]="'checkboxTermsId'" [label]="checkboxTerms.label" [checked]="checkboxTerms.checked"
      name="terms" [value]="checkboxTerms.value" (checkboxChange)="checkboxChange($event)"></voxel-checkbox>
    <div class="link">
      <vcl-link [linkId]="'termsid'" (click)="toggleModal()" [label]="copyService.copies[copiesProperty['termsLabel']]">
      </vcl-link>
    </div>
  </div>
</div>

<div class="detail-account-creation" *ngIf="viewOptionMultiProduct">
  <h2 class="subtitle">
    {{copyService.getParametrizedCopy(copiesProperty['mainLabel2'], [documentInfo.firstname])}}
  </h2>
  <br>
  <div *ngIf="grayZone">
    <p class="subtitle-light">{{ copyService.copies.offer_multi.solicitud }}</p>
    <p class="case-id"> {{this.abreCuentasService.getSolicitationId()}} </p>
  </div>
  <div class="list-product">
    <div *ngFor="let row of dataProducts">
      <div class="product detail" *ngIf="isGranted(row.product_type) || row.product_type === 'savings'">
        <!-- ciclio de productos aprobados -->
        <div *ngIf="!isLoan" class="credit-target" [innerHTML]="row.es"></div>
        <div *ngIf="row.product_type =='creditCard' && !grayZone">

          <!-- <div class="subTitle">{{copyService.copies.account_info_creation.usa_pagues_tittle}}</div> -->
          <p class="credit-text" *ngFor="let transactionkit  of row.transactionkit.share2">
            <span class="subTitle" [innerHtml]="transactionkit.description"></span>
          </p>
          <p>{{copyService.copies.detail_account_no_life_miles[0].description}}</p>
          <br>
          <p>{{copyService.copies.detail_account_no_life_miles[1].description}}</p>
        </div>

        <div class="characters" *ngIf="!isLoan">
          <voxel-icon class="icon">
            inovacao_outline
          </voxel-icon>
          <label class="label">
            {{
            row.es === 'Tarjeta de crédito'
            ? 'Características de tus tarjetas'
            : 'Características de tu ' + row.es
            }}
          </label>
          <voxel-icon (click)="showMore(row.product_type)" Class="arrow" *ngIf="active === row.product_type">
            seta_cima
          </voxel-icon>
          <voxel-icon (click)="showMore(row.product_type)" Class="arrow" *ngIf="active !== row.product_type">
            seta_baixo
          </voxel-icon>
        </div>
        <hr class="xs">
        <div class="showMore" *ngIf="active === row.product_type">
          <div class="detail" *ngIf="row.product_type === 'loan'">
            <div class="case-id">
              <p><strong>{{ copyService.copies.account_info_creation.require_quota_loan }}</strong></p>
              <p class="amountNumber">${{ row.amount }}</p>
            </div>
            <div class="case-id">
              <p><strong>{{copyService.copies.account_info_creation.term}}</strong></p>
              <p>{{ row.maxPeriodValue }}</p>
            </div>
            <div class="case-id">
              <p><strong>{{copyService.copies.account_info_creation.tax}}</strong></p>
              <p class="case-id">{{ row.rate }}</p>
              <p class="info-text"> {{copyService.copies.account_info_creation.tax_loan_1}} </p>
            </div>
            <div class="case-id">
              <p><strong>{{copyService.copies.account_info_creation.life_ensurance_title}}</strong></p>
              <p> {{copyService.copies.account_info_creation.tax_leyend_4}} </p>
            </div>
            <div class="case-id gray_border">
              <p class="case-id padding_space">
                {{copyService.copies.account_info_creation.loan_description}}
              </p>
              <p *ngIf="check">
                {{copyService.copies.account_info_creation.loan_description_check}}
              </p>
              <p class="info-account-selected" *ngIf="accountNumber">
                {{ copyService.copies.account_info_creation.account_selected }}
                <strong>{{ accountNumber }}</strong>.
              </p>
            </div>
            <div class="gray_border" *ngIf="accountNumber === ''">
              <div class="detail_box">
                <div>
                  <h1 class="title_1"> {{copyService.copies.account_info_creation.characteristics_aho}} </h1>
                </div>
                <div class="icon_box"> 
                  <em class="icon-itaufonts_conta_corrente"></em>
                  <strong class="description_feature"> {{copyService.copies.account_info_creation.transaction_cost}} </strong>
                </div>
                <div>
                  <div class="case-id">
                    <p><strong>{{copyService.copies.account_info_creation.withdrawals_itau}}</strong></p>
                    <p> {{copyService.copies.account_info_creation.unlimited}} </p>
                  </div>
                  <div class="case-id">
                    <p><strong>{{copyService.copies.account_info_creation.withdrawals}}</strong></p>
                    <p *ngIf="!showCharacteristics">
                      {{monthly(6)}}
                    </p>
                    <p *ngIf="showCharacteristics">
                      {{monthly(8)}}
                    </p>
                  </div>
                  <div class="case-id">
                    <p><strong>{{copyService.copies.account_info_creation.transfers}}</strong></p>
                    <p> {{ copyService.copies.account_info_creation.unlimited }} </p>
                  </div>
                  <div class="case-id">
                    <p><strong>{{copyService.copies.account_info_creation.manager_checks}}</strong></p>
                    <p *ngIf="!showCharacteristics">
                      {{monthly(1)}}
                    </p>
                    <p *ngIf="showCharacteristics"> 
                      {{monthly(2)}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="aditional-text gray_border" *ngIf="accountNumber === ''">
                <h2><strong>{{copyService.copies.account_info_creation.usa_pagues_tittle}}</strong></h2>
                  <p class="info-text">
                    {{copyService.copies.account_info_creation.usa_pagues_sub1}}
                  </p>
                  <p class="info-text">
                    {{copyService.copies.account_info_creation.usa_pagues_sub2}}
                  </p>
              </div>
            </div>
          </div>
          <div *ngIf="row.product_type == 'creditCard' && !iscardDuality; else duality">
            <div class="cardImages" *ngIf="!grayZone">
              <h1 class="amountNumber" *ngIf="row.granted_product != undefined">{{
                copyService.getParametrizedCopy('detail_account_creation_amount_approved_number',
                [row.granted_product.limit_amount.amount ]) }}</h1>
              <h2 class="subTitleTC">{{ copyService.copies.detail_account_creation_amount_approved }}</h2>

              <img id="visaCreditCard" class="image" src="assets/images/icon-card.svg" alt="Visa"
                *ngIf="selectedPayDayProduct.elementId !== 1" />
              <img id="visaCreditCard" class="image" src="assets/images/Mastercard_preto.svg" alt="MasterCard"
                *ngIf="selectedPayDayProduct.elementId === 1" />
            </div>
          </div>
          <ng-template #duality>
            <vcl-list>
              <li *ngFor="let subRow of row.cardTypes" vclListSimple>
                <div class="cardImages">
                  <br>
                  <h1 class="amountNumber" *ngIf="subRow.granted_product != undefined">{{
                    copyService.getParametrizedCopy('detail_account_creation_amount_approved_number',
                    [subRow.granted_product.limit_amount.amount ]) }}</h1>
                  <h2 class="subTitleTC">{{ copyService.copies.detail_account_creation_amount_approved }}</h2>
                  <br>
                  <img id="visaCreditCard" class="image" src="assets/images/icon-card.svg" alt="Visa"
                    *ngIf="subRow.brand !== 'Mastercard'" />
                  <img id="visaCreditCard" class="image" src="assets/images/Mastercard_preto.svg" alt="MasterCard"
                    *ngIf="subRow.brand === 'Mastercard'" />
                  <div *ngFor="let listRow of subRow.detailDual">
                    <div class="titleTC">{{ listRow.detail }}</div>
                    <div class="subTitleTC" *ngIf="listRow.tag_name == 'typeCard'">{{
                      copyService.getParametrizedCopy('detail_type_card_dual',
                      [subRow.tipo_tarjeta+' '+subRow.brand])}}</div>
                    <div class="subTitleTC" *ngIf="listRow.tag_name == 'virtualCard'">{{ listRow.value }}</div>
                    <div class="subTitleTC" *ngIf="listRow.tag_name == 'quota'">{{
                      copyService.getParametrizedCopy('detail_quota_card_dual',
                      [subRow.meta_facturacion_mensual])}}</div>
                    <div class="subTitleTC" *ngIf="listRow.tag_name == 'payDay'">{{
                      copyService.getParametrizedCopy('detail_pay_day_card_dual',
                      [subRow.payDay]) }}</div>
                    <br>
                  </div>
                </div>
              </li>
            </vcl-list>
          </ng-template>
          <div *ngIf="row.product_type == 'freeInvestment' || row.product_type == 'revolvingCredit'">
            <h2 class="subTitleTC" *ngIf="!grayZone">{{ copyService.copies.account_info_creation.approved_quota_personal
              }}</h2>
            <h2 class="case-id" *ngIf="row.product_type == 'freeInvestment' && grayZone">
              <strong>{{ copyService.copies.gray_zone_multi.valor }} </strong>
              <p class="amountNumber">
                {{copyService.getParametrizedCopy('detail_account_creation_amount_approved_number',
                [row.granted_product.limit_amount.amount ]) }}</p>
            </h2>
            <h1 class="amountNumber" *ngIf="row.granted_product != undefined && !grayZone">{{
              copyService.getParametrizedCopy('detail_account_creation_amount_approved_number',
              [row.granted_product.limit_amount.amount ]) }}</h1>
            <p>{{ copyService.copies.account_info_creation.term }}</p>
            <p *ngIf="row.product_type == 'freeInvestment'">{{ row.maxPeriodValue }} {{
              copyService.copies.type_free.meses }}</p>
            <p *ngIf="row.product_type == 'revolvingCredit'">{{ copyService.copies.account_info_creation.term_value }}
            </p>
            <p *ngIf="row.product_type == 'freeInvestment'">{{ copyService.copies.account_info_creation.tax }}</p>
            <p *ngIf="row.product_type == 'freeInvestment'">{{ row.rate }}</p>
          </div>
          <div *ngIf="row.product_type =='freeInvestment && grayZone'">
            <p> {{ copyService.copies.account_info_creation.tax_leyend_1 }}</p>
            <p>{{ copyService.copies.account_info_creation.tax_leyend_2 }}</p>
          </div>
          <div *ngIf="row.product_type =='revolvingCredit'">
            <p>
              {{copyService.copies.account_info_creation.current_rate}}
              <vcl-link [linkId]="'https://www.itau.co/tasasytarifas'" (click)="goToLink()"
                [label]="copyService.copies.account_info_creation.rates">
              </vcl-link>
            </p>
            <vcl-list *ngIf="row.product_type =='revolvingCredit'">
              <li *ngFor="let listBen of revolvingBenefits" vclListSimple>
                <em class="bullet icon-itaufonts_chat_enviado"></em>
                <vcl-list-text>
                  <div class="subTitleTC">{{listBen}}</div>
                </vcl-list-text>
              </li>
            </vcl-list>
          </div>
          <br>
          <vcl-list *ngIf="!row.iscardDuality && row.product_type == 'creditCard'">
            <li *ngFor="let detail of row.transactionkit.detail" vclListSimple>
              <em class="bullet icon-itaufonts_chat_enviado"></em>
              <vcl-list-text>
                <div class="titleTC">{{ detail.detail }}</div>
                <div class="subTitleTC">{{ detail.value }}</div>
              </vcl-list-text>
            </li>
          </vcl-list>
          <div *ngIf="row.product_type == 'savings' && !isCreateSavingsLoan">
            <vcl-list>
              <li *ngFor="let detail of row.transactionkit.detail" vclListSimple>
                <em class="bullet icon-itaufonts_chat_enviado"></em>
                <vcl-list-text>
                  <div class="titleTC">{{ detail.detail }}</div>
                  <div class="subTitleTC">{{ detail.value }}</div>
                </vcl-list-text>
              </li>
            </vcl-list>
            <div class="subTitle">
              {{copyService.copies.account_info_creation.usa_pagues_tittle}}
            </div>
            <P class="credit-text" *ngFor="let des of row.transactionkit.share">
              <span [innerHtml]="des.description"></span>
            </P>
          </div>
          <div class="aditional-text"
            *ngIf="!grayZone && (row.product_type == 'freeInvestment' || row.product_type == 'revolvingCredit')"
            [ngStyle]="{'border-top': row.product_type === 'freeInvestment'? '1px solid #0000003b' : '' }">
            <P class="credit-text" *ngFor="let row of row.transactionkit">
              <span [innerHtml]="row"></span>
            </P>
          </div>

          <div class="aditional-text" *ngIf="grayZone && row.product_type == 'creditCard' ">
            <h2><strong>{{copyService.copies.account_info_creation.usa_pagues_tittle}}</strong></h2>
            <P class="credit-text" *ngFor="let row of row.transactionkit.share">
              <span [innerHtml]="row.description"></span>
            </P>
            <a class="link link-underline" target="_blank" [href]="copyService.copies.message_grayzone_existent_find_more_information_link">
              {{copyService.copies.message_grayzone_existent_find_more_information_link}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <p class="info-account-selected" *ngIf="(accountNumber || accountNumberRevolving) && !haveloan">
      {{selectedProduct.product_type === 'freeInvestment' || selectedProduct.product_type === 'multi' ?
      copyService.copies.account_info_creation.account_selected :
      copyService.copies.account_info_creation.account_selected_revolving}}
      <strong>{{ accountNumber? accountNumber: accountNumberRevolving }}</strong>.
    </p>
  </div>
  <br>
  <div class="terms" *ngIf="!isLoan">
    <voxel-checkbox [id]="'checkboxTermsId'" [label]="checkboxTerms.label" [checked]="checkboxTerms.checked"
      name="terms" [value]="checkboxTerms.value" (checkboxChange)="checkboxChange($event)"></voxel-checkbox>
    <div class="link" *ngIf="!viewOptionMultiProduct">
      <vcl-link [linkId]="'termsid'" (click)="toggleModal()" [label]="copyService.copies[copiesProperty['termsLabel']]">
      </vcl-link>
    </div>
    <div class="link" *ngIf="viewOptionMultiProduct">
      <a (click)="toggleModalTerms()" class="linkText">{{copyService.copies.detail_account_creation_link_label}}</a>
    </div>
  </div>
  <div class="terms" *ngIf="isLoan">
    <div class="link" *ngIf="viewOptionMultiProduct">
      <p>{{documentation_to_send.sentToEmail}}<a class="linkText">{{documentation_to_send.email}}</a> </p>
    </div>
  </div>
</div>

<app-controls 
  *ngIf="showFotter"
  id="detailAccountCreationBtns"
  [nextLabel]="copyService.copies[copiesProperty['nextButtonLabel']]"
  [nextDisabled]="isBtnDisabled"
  (next)="checkBioCatch()"
  >
</app-controls>